import React from 'react';
import { StripeAmount } from 'client/components/Helpers/Strings';
import classNames from 'classnames';

export function StripeBillingTiersList (props) {
  const { tiers, currency, unitLabel, interval, className } = props;
  const prev = index => tiers[index - 1] ?? {up_to: 0};
  return (
    <ol className={classNames('list-unstyled text-left', className)}>
      {tiers.map((tier, index) => (
        <li key={index} className="xs-mb-10">
          {typeof tier.up_to === 'number' ? (
            <div><strong>{prev(index).up_to + 1} – {tier.up_to} {unitLabel}(s) per {interval}</strong></div>
          ) : (
            <div><strong>{prev(index).up_to + 1}+ {unitLabel}(s) per {interval}</strong></div>
          )}

          {tier.flat_amount && (
            <div>
              <StripeAmount currency={currency} amount={tier.flat_amount} />
              {' '}/ {interval}
            </div>
          )}

          {tier.unit_amount > 0 && (
            <div>
              <StripeAmount currency={currency} amount={tier.unit_amount} roundTo={2} />
              {unitLabel && (
                <span>
                  {' '}per {unitLabel}
                </span>
              )}
            </div>
          )}

        </li>
      ))}
    </ol>
  );
}
